import React, { useState } from 'react'
import Editors from '../Components/Editor/Editor'
import Wmbutton from '../ui-components/wm-button/Wm.button';
import { connect } from "react-redux";
import { updateInstituteBio } from '../functions/apis'
import CircularProgress from "@material-ui/core/CircularProgress";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";

const cookies = new Cookies();
function Institute({ rootData }) {
    const history = useHistory();
    var token = cookies.get("wmtoken");
    const [instituteBio, setInstituteBio] = useState(rootData.bio)
    const [isUpdating, setIsUpdating] = useState(false)
    const handleInstituteBio = () => {
        setIsUpdating(true)
        updateInstituteBio(instituteBio)
            .then(function (res) {
                if(res.message === 'Profile Details Updated Successfully'){
                    setIsUpdating(false)
                    alert('Institute overview is updated successfully')
                }
            })
            .catch(function (err) {
                setIsUpdating(false)
                console.log(err)
            })
    }
    const backToLoginPage = () => {
        history.push("/login");
    };
    return (
        <>
            {token ? <div className=" mb-20 md:mb-0">
                <div className="row">
                    <div className="col-md-12">
                        <span className="manpro font-semibold text-3xl block mb-2">Overview</span>
                    </div>
                    <div className="col-md-12">
                        <div><Editors onEditorStateChange={(e, value) => setInstituteBio(value)} value={instituteBio} /></div>
                    </div>
                    <div className="col-md-12">
                        <div>
                            <Wmbutton className="w-40 mr-3 mt-3 h-10 rounded" label={isUpdating ? <CircularProgress className="loader_size_xsm" style={{ color: "white" }}/>: "Update Bio"} type="button" color="primary" onClick={handleInstituteBio}/>
                        </div>
                    </div>
                </div>
            </div> : backToLoginPage()}
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps, null)(Institute)
